import React, {Suspense} from 'react';
import {Pane, toaster} from 'evergreen-ui';
import ReportsSidebar from 'Features/Reports/Reports.Sidebar';
import {Outlet} from 'react-router-dom';
import SuspenseSpinner from 'Utils/SuspenseSpinner';
import {useSelector} from "react-redux";
import {timeZoneSelector} from "../App/appSlice";
import {formingReportCsvZip} from "../../Services/api/reportsApi";
import {flushSync} from "react-dom";
import {userNameSelector} from "./ReportsUserNameSelector";

export default function Reports() {
  const [canDownloadSelected, setCanDownloadSelected] = React.useState(false)
  const [selectedReports, setSelectedReports] = React.useState(new Set())
  const timeZone = useSelector(timeZoneSelector, (a, b) => a['reports'] === b['reports']);
  const userName = useSelector(userNameSelector)

  function onChange(report, event) {
      if (event.target.checked) {
        const newFilters = selectedReports;
        if (!newFilters.has(report)) {
          newFilters.add(report)
          flushSync(() => {
            setSelectedReports(newFilters);
          })
        }
        flushSync(() => {
          setCanDownloadSelected(true)
        })
      } else {
        const newFilters = selectedReports;
        newFilters.delete(report)
        flushSync(() => {
          setSelectedReports(newFilters);
          setCanDownloadSelected(newFilters.size !== 0)
        })
      }
  }


  async function downloadAllSelectedReports() {
    await formingReportCsvZip(
      Array.from(selectedReports).map((el) => el['id']).toString(),
      parseInt(
      timeZone['reports']
        .split(':')
        [0]
        .replaceAll('-', "")
        .replaceAll('+', "")
      ),
      userName
    )
    toaster.success('Архив отчетов формируется...');
  }

  return (
    <Pane
      display="grid"
      overflow="hidden"
      position="relative"
      gridTemplateColumns="max-content 1fr"
    >
      {
        ReportsSidebar(
            canDownloadSelected,
            onChange,
            downloadAllSelectedReports
        )}
      <Suspense fallback={<SuspenseSpinner />}>
          <Outlet />
      </Suspense>
    </Pane>
  );
}
